"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Vrati casti dotazu spojene podminkou AND. Pokud nejsou zadane zadne casti vrati `undefined`.
 *
 * @param {void | Array<Object>} parts Casti dotazu.
 * @returns {}
 */
var andToQuery = function andToQuery(parts) {
  return !parts || parts.length === 0 ? undefined : {
    $and: parts
  };
};

var _default = andToQuery;
exports.default = _default;